import { action } from 'typesafe-actions';
import { REPORT } from '../constants/actions';

export const getInventoryReport   = (payload: string) => action(REPORT.GET_INVENTORY_REPORT, payload);
export const setInventoryReport   = (data: any) => action(REPORT.SET_INVENTORY_REPORT, data);
